import { Component, Input, OnInit } from '@angular/core';
import { DataTablesService } from '../../../../../core';
import { PedidoItemDescontoMaximoExcedidoResponse } from '../../adapters';

interface Config {
    isLoading: boolean;
}

@Component({
    selector: 'pedido-item-desconto-maximo-excedido-table',
    templateUrl: './pedido-item-desconto-maximo-excedido-table.component.html',
    styleUrls: ['./pedido-item-desconto-maximo-excedido-table.component.less']
})
export class PedidoItemDescontoMaximoExcedidoTableComponent implements OnInit {
    config: Config;

    // Table
    @Input() idTable = 'tablePedidoItensDescontosMaximosExcedidos';
    dataTable: any;
    /** Itens com descontos máximos excedidos */
    @Input() pedidosItens: PedidoItemDescontoMaximoExcedidoResponse[];

    constructor(private dataTablesService: DataTablesService) { }

    ngOnInit(): void {
        this.createTable();
    }


    /** Cria a dataTable */
    private createTable(): Promise<void> {
        return new Promise<void>((resolve) => {
            this.dataTablesService.showTable(`#${this.idTable}`, this.dataTable, {
                columnDefs: [
                    {orderable: true, targets: 0}
                ],
                order: [[0, 'asc']],
                searching: false,
                info: false,
                paging: false
            }).then(dataTable => {
                this.dataTable = dataTable;
                resolve();
            })
            .catch(() => {});
        });
    }

}
